import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { postRequest } from 'src/lib/core/api-client'
import { useLocale } from 'src/lib/hooks/useLocal'
import { apiURI } from 'src/lib/utils/constants'
import { validateEmail } from 'src/lib/utils/helpers'
import Alerts from '../common/feedback-and-dialog/Alerts'

const EmailExpired = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { email, token } = router.query

  const { setLoaderProperties, loaderConfig } = useLoader()

  const [openAlert, setOpenAlert] = useState<string>('')
  const [alertMessage, setAlertMessage] = useState<string>('')

  useEffect(() => {
    if (!Boolean(validateEmail(String(email))) && !Boolean(token)) {
      router.replace('/auth/login')
    }
  }, [email])

  useEffect(() => {
    resendInvitation()
  }, [])

  const handleAlerts = (severity: string, message?: string) => {
    setOpenAlert(severity)
    message && setAlertMessage(message)
  }

  const handleCloseAlert = (_event: any, reason: string) => {
    if (reason === 'clickaway') {
      return
    }
    handleAlerts('')
  }

  const resendInvitation = async () => {
    if (!Boolean(token)) return
    const payload = { invitation_id: token }
    try {
      await postRequest('/merchant-invitation/resend', apiURI.AUTH_ENGINE, payload)
    } catch (error: any) {
      console.error(error)
    }
  }

  if (Boolean(loaderConfig.isLoaderVisible)) return <></>

  return (
    <>
      <div className='flex flex-col items-center gap-3'>
        <p className='text-[#ffffff] text-[18px] font-semibold'>{t('expired_email')}</p>
        <p className='text-[#B6B6BC] text-sm'>{t('expired_email_text', { email: email })}</p>
      </div>
      {openAlert.length ? (
        <Alerts
          open={true}
          duration={2000}
          closeHandler={handleCloseAlert}
          severity={openAlert}
          message={alertMessage}
        />
      ) : null}
    </>
  )
}

export default EmailExpired
